import moment from 'moment'
import React from 'react'
import { Link } from 'react-router-dom'
import logo from '../../../assets/Aspom-Logo.png'
import profile from '../../../assets/profile.png'

const Payslip = () => {
  return (
    <section className='payroll'>
         {/* HEADING */}
        <div className="heading">
            <div className="heading__box">
                <div className="heading-item">
                    <h3 className="heading-title">Pay Slip | </h3>
                    <i class='bx bx-home heading__title-icon'></i>
                    <Link to="/" className="heading-text">
                        Home <i class='bx bx-chevron-right heading-icon'></i>
                    </Link>
                    <span className="heading-text">
                        Pay Slip <i class='bx bx-chevron-right heading-icon'></i>
                    </span>
                </div>
                <p className="heading-text">
                    Employee Pay Slip
                </p>
            </div>
            <div className="payslip__btn">
                <button 
                className="heading__box-btn button">
                    PRINT
                </button>
                <button
                className="heading__box-btn button">
                    Download
                </button>
            </div>
        </div>

        <div className="payslip__container">
            <h2 className="payslip__title">
                Payslip for the month of {moment().format('MMMM YYYY')}
            </h2>
            <div className="payslip__heading">
                <img src={logo} alt="" className="payslip__heading-img" />
                <div className="payslip__header">
                    <h2 className="payslip__header-title">
                        payslip #478283
                    </h2>
                    <span className="payslip__header-subtitle">
                        Salary Month: {moment().format('MMMM YYYY')}
                    </span>
                </div>
            </div>
            <div className="payslip__content">
                <div className="payslip__profile">
                    <span className="payslip__profile-text">
                        Aspom Travels Agency
                    </span>
                    <span className="payslip__profile-text">
                        Bridge gate estate, agungi bus-stop, lekki, lagos.
                    </span>
                </div>
                <div className="payslip__profile">
                    <img src={profile} alt="" className="payslip__profile-img" />
                    <span className="payslip__profile-text">
                        Steve Moran
                    </span>
                    <span className="payslip__profile-text">
                        Visa Officer
                    </span>
                    <span className="payslip__profile-text">
                        Employee ID: 8398392
                    </span>
                    <span className="payslip__profile-text">
                        Join Date: 2/8/2113
                    </span>
                </div>
                <div className="payslip__account">
                    <div className="payslip__account-items">
                        <h4 className="payslip__account-title">
                            Earning
                        </h4>
                        <div className="payslip__account-list">
                            <div className="payslip__account-item">
                                <span className="payslip__account-item_title">
                                    Basic Salary:
                                </span>
                                <span className="payslip__account-item_value">
                                    $200.00
                                </span>
                            </div>
                            <div className="payslip__account-item">
                                <span className="payslip__account-item_title">
                                    Allowance:
                                </span>
                                <span className="payslip__account-item_value">
                                    $00.00
                                </span>
                            </div>
                            <div className="payslip__account-item">
                                <span className="payslip__account-item_title">
                                    Total Earnings:
                                </span>
                                <span className="payslip__account-item_value">
                                    $00.00
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="payslip__account-items">
                        <h4 className="payslip__account-title">
                            Deductions
                        </h4>
                        <div className="payslip__account-list">
                            <div className="payslip__account-item">
                                <span className="payslip__account-item_title">
                                    House Rent:
                                </span>
                                <span className="payslip__account-item_value">
                                    $10.00
                                </span>
                            </div>
                            <div className="payslip__account-item">
                                <span className="payslip__account-item_title">
                                    Tax:
                                </span>
                                <span className="payslip__account-item_value">
                                    $4.00
                                </span>
                            </div>
                            <div className="payslip__account-item">
                                <span className="payslip__account-item_title">
                                    Sanction:
                                </span>
                                <span className="payslip__account-item_value">
                                    $12.00
                                </span>
                            </div>
                            <div className="payslip__account-item">
                                <span className="payslip__account-item_title">
                                    Total Deduction:
                                </span>
                                <span className="payslip__account-item_value">
                                    $26.00
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <span className="payslip__total">
                    Total Net Salary: $174.90
                </span>
            </div>
        </div>

    </section>
  )
}

export default Payslip